import { api } from './api';
import type {
  ConfigurationMenuResponse,
  ConfigurationMetadata,
  NextResponse,
  OptionSaveResponse,
  PlanimetryDescriptor,
  SaveAnswerRequest,
  SaveAnswerResponse,
  SubstepOptionsResponse,
  SubstepPackagesResponse,
} from '@/types';

export const wizardApi = {
  getMetadata: (configurationId: number): Promise<ConfigurationMetadata> =>
    api
      .get<ConfigurationMetadata>(`/api/configurations/${configurationId}`)
      .then((r) => r.data),

  getMenu: (configurationId: number): Promise<ConfigurationMenuResponse> =>
    api
      .get<ConfigurationMenuResponse>(`/api/configurations/${configurationId}/menu`)
      .then((r) => r.data),

  getPackages: (
    configurationId: number,
    substepId: number,
    roomId?: number | null,
  ): Promise<SubstepPackagesResponse> =>
    api
      .get<SubstepPackagesResponse>(
        `/api/configurations/${configurationId}/substeps/${substepId}/packages`,
        { params: roomId != null ? { roomId } : undefined },
      )
      .then((r) => r.data),

  getOptions: (
    configurationId: number,
    substepId: number,
    roomId?: number | null,
  ): Promise<SubstepOptionsResponse> =>
    api
      .get<SubstepOptionsResponse>(
        `/api/configurations/${configurationId}/substeps/${substepId}/options`,
        { params: roomId != null ? { roomId } : undefined },
      )
      .then((r) => r.data),

  getNext: (
    configurationId: number,
    currentSubstepId: number,
    roomId?: number | null,
  ): Promise<NextResponse> =>
    api
      .get<NextResponse>(`/api/configurations/${configurationId}/next`, {
        params: {
          currentSubstepId,
          ...(roomId != null ? { roomId } : {}),
        },
      })
      .then((r) => r.data),

  getPlanimetry: (
    configurationId: number,
    view?: 'plan' | 'elettrico',
    roomId?: number | null,
    highlight?: 'room' | null,
  ): Promise<PlanimetryDescriptor> =>
    api
      .get<PlanimetryDescriptor>(`/api/configurations/${configurationId}/planimetry`, {
        params: {
          ...(view != null ? { view } : {}),
          ...(roomId != null ? { roomId } : {}),
          ...(highlight != null ? { highlight } : {}),
        },
      })
      .then((r) => r.data),

  saveAnswer: (
    configurationId: number,
    payload: SaveAnswerRequest,
    dryRun = false,
  ): Promise<SaveAnswerResponse> =>
    api
      .post<SaveAnswerResponse>(`/api/configurations/${configurationId}/answers`, payload, {
        params: dryRun ? { dryRun: true } : undefined,
      })
      .then((r) => r.data),

  /**
   * Salva la risposta a OPZIONE (fasi 1-2): `options[]` SOSTITUISCE l'insieme corrente del substep.
   * Con `dryRun=true` restituisce solo il piano (toDeleteIds) per l'anteprima delle invalidazioni.
   */
  saveOptions: (
    configurationId: number,
    payload: { substepId: number; options: number[]; roomId?: number },
    dryRun = false,
  ): Promise<OptionSaveResponse> =>
    api
      .post<OptionSaveResponse>(`/api/configurations/${configurationId}/answers`, payload, {
        params: dryRun ? { dryRun: true } : undefined,
      })
      .then((r) => r.data),
};
